import React from 'react';
import useSmallScreen from 'hooks/useSmallScreen';

import HCMap from 'components/HCMap/HCMap.js';

type AddressMapProps = {
  latitude: string;
  longitude: string;
};
const AddressMap = ({ latitude, longitude }: AddressMapProps) => {
  const latLong = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
  const isSmallScreen = useSmallScreen();
  const largeMapHeight = 278;
  const smallMapHeight = 211;
  return (
    <HCMap
      showZoomControl={false}
      showMapControl={false}
      center={latLong}
      mapContainerStyle={{ height: isSmallScreen ? largeMapHeight : smallMapHeight }}
      markers={[{ position: latLong }]}
    />
  );
};

export default AddressMap;
